var _excluded = ["styles"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createStyles } from '@udecode/plate-styled-components';
import _styled, { css } from 'styled-components';
import React, { useState, useRef, forwardRef, useMemo } from 'react';
import useMergedRef from '@react-hook/merged-ref';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useEditorRef } from '@udecode/plate-core';
import { useDrag, useDrop } from 'react-dnd';
import { findNode, isExpanded, createNodesWithHOC, getNodes, unhangRange } from '@udecode/plate-common';
import { Path, Transforms, Editor } from 'slate';
import { ReactEditor, useReadOnly } from 'slate-react';
var createDndPlugin = function createDndPlugin() {
  return {
    onDrop: function onDrop(editor) {
      return function () {
        return editor.isDragging;
      };
    }
  };
};
var getDraggableStyles = function getDraggableStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'Draggable'
  }, props), {
    root: [{
      "position": "relative"
    }, props.isDragging && {
      "opacity": "0.5"
    }, props.selected && {
      "backgroundColor": "rgb(181, 215, 255)"
    }, css([":hover .slate-Draggable-gutterLeft{", "}"], {
      "opacity": "1"
    })],
    block: {
      "overflow": "auto"
    },
    gutterLeft: [{
      "position": "absolute",
      "top": "0px",
      "display": "flex",
      "height": "100%",
      "opacity": "0"
    }, css(["transform:translateX(-100%);"])],
    blockToolbarWrapper: {
      "display": "flex",
      "height": "1.5em"
    },
    blockToolbar: {
      "display": "flex",
      "alignItems": "center",
      "marginRight": "0.25rem",
      "pointerEvents": "auto"
    },
    dragHandle: [{
      "padding": "0px",
      "backgroundColor": "transparent",
      "backgroundRepeat": "no-repeat",
      "cursor": "pointer",
      "overflow": "hidden",
      "outline": "2px solid transparent",
      "outlineOffset": "2px",
      "borderStyle": "none"
    }, {
      "minWidth": "18px",
      "height": "18px"
    }],
    dropLine: [{
      "position": "absolute",
      "left": "0px",
      "right": "0px",
      "height": "0.125rem",
      "opacity": "1"
    }, {
      "background": "#B4D5FF"
    }, props.direction === 'top' && {
      "top": "-1px"
    }, props.direction === 'bottom' && {
      "bottom": "-1px"
    }]
  });
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var useDragBlock = function useDragBlock(editor, id) {
  return useDrag(function () {
    return {
      type: 'block',
      item: function item() {
        editor.isDragging = true;
        document.body.classList.add('dragging');
        return {
          id: id
        };
      },
      collect: function collect(monitor) {
        return {
          isDragging: monitor.isDragging()
        };
      },
      end: function end() {
        editor.isDragging = false;
        document.body.classList.remove('dragging');
      }
    };
  }, []);
};

/**
 * If dragging a block A over another block B:
 * get the direction of block A relative to block B.
 */
var getHoverDirection = function getHoverDirection(dragItem, monitor, ref, hoverId) {
  var _ref$current;
  if (!ref.current) return;
  var dragId = dragItem.id; // Don't replace items with themselves

  if (dragId === hoverId) return; // Determine rectangle on screen

  var hoverBoundingRect = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect(); // Get vertical middle

  var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2; // Determine mouse position

  var clientOffset = monitor.getClientOffset();
  if (!clientOffset) return; // Get pixels to the top

  var hoverClientY = clientOffset.y - hoverBoundingRect.top; // Only perform the move when the mouse has crossed half of the items height
  // When dragging downwards, only move when the cursor is below 50%
  // When dragging upwards, only move when the cursor is above 50%
  // Dragging downwards
  // if (dragId < hoverId && hoverClientY < hoverMiddleY) {

  if (hoverClientY < hoverMiddleY) {
    return 'top';
  } // Dragging upwards
  // if (dragId > hoverId && hoverClientY > hoverMiddleY) {

  if (hoverClientY >= hoverMiddleY) {
    return 'bottom';
  }
};

/**
 * Get new direction if updated
 */
var getNewDirection = function getNewDirection(previousDir, dir) {
  if (!dir && previousDir) {
    return '';
  }
  if (dir === 'top' && previousDir !== 'top') {
    return 'top';
  }
  if (dir === 'bottom' && previousDir !== 'bottom') {
    return 'bottom';
  }
};
var useDropBlockOnEditor = function useDropBlockOnEditor(editor, _ref) {
  var blockRef = _ref.blockRef,
    id = _ref.id,
    dropLine = _ref.dropLine,
    setDropLine = _ref.setDropLine;
  return useDrop({
    accept: 'block',
    drop: function drop(dragItem, monitor) {
      var direction = getHoverDirection(dragItem, monitor, blockRef, id);
      if (!direction) return;
      var dragEntry = findNode(editor, {
        at: [],
        match: {
          id: dragItem.id
        }
      });
      if (!dragEntry) return;
      var _dragEntry = _slicedToArray(dragEntry, 2),
        dragPath = _dragEntry[1];
      ReactEditor.focus(editor);
      var dropPath;
      if (direction === 'bottom') {
        var _findNode;
        dropPath = (_findNode = findNode(editor, {
          at: [],
          match: {
            id: id
          }
        })) === null || _findNode === void 0 ? void 0 : _findNode[1];
        if (!dropPath) return;
        if (Path.equals(dragPath, Path.next(dropPath))) return;
      }
      if (direction === 'top') {
        var _findNode2;
        var nodePath = (_findNode2 = findNode(editor, {
          at: [],
          match: {
            id: id
          }
        })) === null || _findNode2 === void 0 ? void 0 : _findNode2[1];
        if (!nodePath) return;
        dropPath = [].concat(_toConsumableArray(nodePath.slice(0, -1)), [nodePath[nodePath.length - 1] - 1]);
        if (Path.equals(dragPath, dropPath)) return;
      }
      if (direction) {
        var _dropPath = dropPath;
        var before = Path.isBefore(dragPath, _dropPath) && Path.isSibling(dragPath, _dropPath);
        var to = before ? _dropPath : Path.next(_dropPath);
        Transforms.moveNodes(editor, {
          at: dragPath,
          to: to
        });
      }
    },
    collect: function collect(monitor) {
      return {
        isOver: monitor.isOver()
      };
    },
    hover: function hover(item, monitor) {
      var direction = getHoverDirection(item, monitor, blockRef, id);
      var dropLineDir = getNewDirection(dropLine, direction);
      if (dropLineDir) setDropLine(dropLineDir);
      if (direction && isExpanded(editor.selection)) {
        ReactEditor.focus(editor);
        Transforms.collapse(editor);
      }
    }
  });
};
var useDndBlock = function useDndBlock(_ref2) {
  var id = _ref2.id,
    blockRef = _ref2.blockRef,
    removePreview = _ref2.removePreview;
  var editor = useEditorRef();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    dropLine = _useState2[0],
    setDropLine = _useState2[1];
  var _useDragBlock = useDragBlock(editor, id),
    _useDragBlock2 = _slicedToArray(_useDragBlock, 3),
    isDragging = _useDragBlock2[0].isDragging,
    dragRef = _useDragBlock2[1],
    preview = _useDragBlock2[2];
  var _useDropBlockOnEditor = useDropBlockOnEditor(editor, {
      id: id,
      blockRef: blockRef,
      dropLine: dropLine,
      setDropLine: setDropLine
    }),
    _useDropBlockOnEditor2 = _slicedToArray(_useDropBlockOnEditor, 2),
    isOver = _useDropBlockOnEditor2[0].isOver,
    drop = _useDropBlockOnEditor2[1]; // TODO: previewElement option

  if (removePreview) {
    drop(blockRef);
    preview(getEmptyImage(), {
      captureDraggingState: true
    });
  } else {
    preview(drop(blockRef));
  }
  if (!isOver && dropLine) {
    setDropLine('');
  }
  return {
    isDragging: isDragging,
    dropLine: dropLine,
    dragRef: dragRef
  };
};
var DefaultDragHandle = function DefaultDragHandle(_ref3) {
  var styles = _ref3.styles,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(_StyledButton, _extends({
    type: "button"
  }, props, {
    $_css: styles
  }));
};
var Draggable = function Draggable(props) {
  var _styles$blockAndGutte, _styles$blockAndGutte2, _styles$block$css, _styles$block, _styles$dropLine, _styles$dropLine2, _styles$gutterLeft, _styles$blockAndGutte3, _styles$blockAndGutte4, _styles$gutterLeft$cs, _styles$gutterLeft2, _styles$blockToolbarW, _styles$blockToolbarW2, _styles$blockToolbar, _styles$blockToolbar2, _styles$dragHandle, _styles$dragHandle2;
  var children = props.children,
    element = props.element,
    componentRef = props.componentRef,
    onRenderDragHandle = props.onRenderDragHandle;
  var DragHandle = onRenderDragHandle !== null && onRenderDragHandle !== void 0 ? onRenderDragHandle : DefaultDragHandle;
  var blockRef = useRef(null);
  var rootRef = useRef(null);
  var dragWrapperRef = useRef(null);
  var multiRootRef = useMergedRef(componentRef, rootRef);
  var _useDndBlock = useDndBlock({
      id: element.id,
      blockRef: rootRef
    }),
    dropLine = _useDndBlock.dropLine,
    dragRef = _useDndBlock.dragRef,
    isDragging = _useDndBlock.isDragging;
  var multiDragRef = useMergedRef(dragRef, dragWrapperRef);
  var styles = getDraggableStyles(_objectSpread(_objectSpread({}, props), {}, {
    direction: dropLine,
    isDragging: isDragging
  }));
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: styles.root.className,
    ref: multiRootRef,
    $_css2: styles.root.css
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    ref: blockRef,
    $_css3: [].concat(_toConsumableArray((_styles$blockAndGutte = (_styles$blockAndGutte2 = styles.blockAndGutter) === null || _styles$blockAndGutte2 === void 0 ? void 0 : _styles$blockAndGutte2.css) !== null && _styles$blockAndGutte !== void 0 ? _styles$blockAndGutte : []), _toConsumableArray((_styles$block$css = (_styles$block = styles.block) === null || _styles$block === void 0 ? void 0 : _styles$block.css) !== null && _styles$block$css !== void 0 ? _styles$block$css : []))
  }, children, !!dropLine && /*#__PURE__*/React.createElement(_StyledDiv3, {
    className: (_styles$dropLine = styles.dropLine) === null || _styles$dropLine === void 0 ? void 0 : _styles$dropLine.className,
    contentEditable: false,
    $_css4: (_styles$dropLine2 = styles.dropLine) === null || _styles$dropLine2 === void 0 ? void 0 : _styles$dropLine2.css
  })), /*#__PURE__*/React.createElement(_StyledDiv4, {
    className: (_styles$gutterLeft = styles.gutterLeft) === null || _styles$gutterLeft === void 0 ? void 0 : _styles$gutterLeft.className,
    contentEditable: false,
    $_css5: [].concat(_toConsumableArray((_styles$blockAndGutte3 = (_styles$blockAndGutte4 = styles.blockAndGutter) === null || _styles$blockAndGutte4 === void 0 ? void 0 : _styles$blockAndGutte4.css) !== null && _styles$blockAndGutte3 !== void 0 ? _styles$blockAndGutte3 : []), _toConsumableArray((_styles$gutterLeft$cs = (_styles$gutterLeft2 = styles.gutterLeft) === null || _styles$gutterLeft2 === void 0 ? void 0 : _styles$gutterLeft2.css) !== null && _styles$gutterLeft$cs !== void 0 ? _styles$gutterLeft$cs : []))
  }, /*#__PURE__*/React.createElement(_StyledDiv5, {
    className: (_styles$blockToolbarW = styles.blockToolbarWrapper) === null || _styles$blockToolbarW === void 0 ? void 0 : _styles$blockToolbarW.className,
    $_css6: (_styles$blockToolbarW2 = styles.blockToolbarWrapper) === null || _styles$blockToolbarW2 === void 0 ? void 0 : _styles$blockToolbarW2.css
  }, /*#__PURE__*/React.createElement(_StyledDiv6, {
    className: (_styles$blockToolbar = styles.blockToolbar) === null || _styles$blockToolbar === void 0 ? void 0 : _styles$blockToolbar.className,
    ref: multiDragRef,
    $_css7: (_styles$blockToolbar2 = styles.blockToolbar) === null || _styles$blockToolbar2 === void 0 ? void 0 : _styles$blockToolbar2.css
  }, /*#__PURE__*/React.createElement(DragHandle, {
    element: element,
    styles: (_styles$dragHandle = styles.dragHandle) === null || _styles$dragHandle === void 0 ? void 0 : _styles$dragHandle.css,
    className: (_styles$dragHandle2 = styles.dragHandle) === null || _styles$dragHandle2 === void 0 ? void 0 : _styles$dragHandle2.className,
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    }
  })))));
};
var _StyledButton = _styled("button").withConfig({
  displayName: "Draggable___StyledButton",
  componentId: "sc-1c1pto8-0"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "Draggable___StyledDiv",
  componentId: "sc-1c1pto8-1"
})(["", ""], function (p) {
  return p.$_css2;
});
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "Draggable___StyledDiv2",
  componentId: "sc-1c1pto8-2"
})(["", ""], function (p) {
  return p.$_css3;
});
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "Draggable___StyledDiv3",
  componentId: "sc-1c1pto8-3"
})(["", ""], function (p) {
  return p.$_css4;
});
var _StyledDiv4 = _styled("div").withConfig({
  displayName: "Draggable___StyledDiv4",
  componentId: "sc-1c1pto8-4"
})(["", ""], function (p) {
  return p.$_css5;
});
var _StyledDiv5 = _styled("div").withConfig({
  displayName: "Draggable___StyledDiv5",
  componentId: "sc-1c1pto8-5"
})(["", ""], function (p) {
  return p.$_css6;
});
var _StyledDiv6 = _styled("div").withConfig({
  displayName: "Draggable___StyledDiv6",
  componentId: "sc-1c1pto8-6"
})(["", ""], function (p) {
  return p.$_css7;
});
var GrabberTooltipContent = function GrabberTooltipContent() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("div", null, "Drag ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'rgba(255, 255, 255, 0.45)'
    }
  }, "to move")));
};
var grabberTooltipProps = {
  content: /*#__PURE__*/React.createElement(GrabberTooltipContent, null),
  placement: 'bottom',
  arrow: false,
  offset: [0, 0],
  delay: [300, 0],
  duration: [0, 0],
  hideOnClick: true,
  theme: 'small'
};
var withDraggable = function withDraggable(Component) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    styles = _ref4.styles,
    level = _ref4.level,
    filter = _ref4.filter,
    _ref4$allowReadOnly = _ref4.allowReadOnly,
    allowReadOnly = _ref4$allowReadOnly === void 0 ? false : _ref4$allowReadOnly,
    onRenderDragHandle = _ref4.onRenderDragHandle;
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var attributes = props.attributes,
      element = props.element;
    var editor = useEditorRef();
    var readOnly = useReadOnly();
    var path = useMemo(function () {
      return ReactEditor.findPath(editor, element);
    }, [editor, element]);
    var filteredOut = useMemo(function () {
      return Number.isInteger(level) && level !== path.length - 1 || filter && filter(editor, path);
    }, [path, editor]);
    if (filteredOut || !allowReadOnly && readOnly) {
      return /*#__PURE__*/React.createElement(Component, props);
    }
    return /*#__PURE__*/React.createElement(Draggable, {
      attributes: attributes,
      element: element,
      componentRef: ref,
      styles: styles,
      onRenderDragHandle: onRenderDragHandle
    }, /*#__PURE__*/React.createElement(Component, props));
  });
};
var withDraggables = createNodesWithHOC(withDraggable);

/**
 * Select the start of a block by id and focus the editor.
 */

var focusBlockStartById = function focusBlockStartById(editor, id) {
  var _findNode;
  var path = (_findNode = findNode(editor, {
    at: [],
    match: {
      id: id
    }
  })) === null || _findNode === void 0 ? void 0 : _findNode[1];
  if (!path) return;
  Transforms.select(editor, Editor.start(editor, path));
  ReactEditor.focus(editor);
};

/**
 * Get blocks with an id
 */

var getBlocksWithId = function getBlocksWithId(editor, options) {
  return _toConsumableArray(getNodes(editor, _objectSpread({
    match: function match(n) {
      return Editor.isBlock(editor, n) && !!n.id;
    }
  }, options)));
};

/**
 * Get node entries range.
 */

var getNodesRange = function getNodesRange(editor, nodeEntries) {
  if (!nodeEntries.length) return;
  var firstBlockPath = nodeEntries[0][1];
  var lastBlockPath = nodeEntries[nodeEntries.length - 1][1];
  return Editor.range(editor, firstBlockPath, lastBlockPath);
};

/**
 * Remove blocks with an id and focus the editor.
 */

var removeBlocksAndFocus = function removeBlocksAndFocus(editor, options) {
  unhangRange(editor, options);
  var nodeEntries = getBlocksWithId(editor, options);
  Transforms.removeNodes(editor, {
    at: getNodesRange(editor, nodeEntries)
  });
  ReactEditor.focus(editor);
};

/**
 * Select the block above the selection by id and focus the editor.
 */

var selectBlockById = function selectBlockById(editor, id) {
  var _findNode;
  var path = (_findNode = findNode(editor, {
    at: [],
    match: {
      id: id
    }
  })) === null || _findNode === void 0 ? void 0 : _findNode[1];
  if (!path) return;
  Transforms.select(editor, Editor.range(editor, path));
  ReactEditor.focus(editor);
};

/**
 * Select blocks by selection or by id.
 * If the block with id is not selected, select the block with id.
 * Else, select the blocks above the selection.
 */

var selectBlocksBySelectionOrId = function selectBlocksBySelectionOrId(editor, id) {
  if (!editor.selection) return;
  var blockEntries = getBlocksWithId(editor, {
    at: editor.selection
  });
  var isBlockSelected = blockEntries.some(function (blockEntry) {
    return blockEntry[0].id === id;
  });
  if (isBlockSelected) {
    Transforms.select(editor, getNodesRange(editor, blockEntries));
    ReactEditor.focus(editor);
  } else {
    selectBlockById(editor, id);
  }
};
export { Draggable, createDndPlugin, focusBlockStartById, getBlocksWithId, getDraggableStyles, getHoverDirection, getNewDirection, getNodesRange, grabberTooltipProps, removeBlocksAndFocus, selectBlockById, selectBlocksBySelectionOrId, useDndBlock, useDragBlock, useDropBlockOnEditor, withDraggable, withDraggables };